async function l(e) {
  const a = window.electronAPI;
  if (a?.copyToClipboard) {
    await a.copyToClipboard(e);
    return;
  }
  await navigator.clipboard.writeText(e);
}
async function n(e) {
  return new Promise((a, t) => {
    const r = new FileReader();
    r.onerror = () => t(r.error ?? new Error("Failed to read blob")), r.onload = () => a(String(r.result)), r.readAsDataURL(e);
  });
}
async function i(e) {
  if (e.startsWith("data:"))
    return e;
  const a = await fetch(e);
  if (!a.ok)
    throw new Error(`Failed to fetch image: ${a.status}`);
  return n(await a.blob());
}
async function c(e) {
  const a = window.electronAPI;
  if (a?.copyImageToClipboard) {
    const o = e.filePath ? void 0 : await i(e.src);
    await a.copyImageToClipboard({
      filePath: e.filePath,
      dataUrl: o
    });
    return;
  }
  const t = await fetch(e.src);
  if (!t.ok)
    throw new Error(`Failed to fetch image: ${t.status}`);
  const r = await t.blob();
  if (typeof ClipboardItem > "u")
    throw new Error("Image clipboard is not supported in this environment");
  await navigator.clipboard.write([
    new ClipboardItem({
      [r.type || "image/png"]: r
    })
  ]);
}
function d(e) {
  return e.files.length === 0 && !e.getData("text/plain") && !e.getData("text/html");
}
async function s() {
  const e = window.electronAPI;
  if (!e?.readWindowsClipboardImage) return null;
  try {
    const a = await e.readWindowsClipboardImage();
    return a ? new File([a.data], "image.png", { type: a.mimeType }) : null;
  } catch (a) {
    return console.warn("[clipboard] Could not read the Windows clipboard image", a), null;
  }
}
export {
  c as copyImageToClipboard,
  l as copyToClipboard,
  d as isEmptyPaste,
  s as readWindowsClipboardImage
};
//# sourceMappingURL=clipboard-hsoeGPuZ.js.map
